<template>
	<div class="table-contracts">
		<table class="table" id="tableContracts">
				<thead>
						<tr>
								<th>ID</th>
								<th>Activo</th>
								<th>Número</th>
								<th>Inicio</th>
								<th>Finalización</th>
								<th>Estado</th>
								<th>Observaciones</th>
								<th>Editar</th>
								<th>productos</th>
						</tr>
				</thead>
				<tbody>
						<tr v-for="contract in contracts" :key="contract.id">
							<td>{{contract.id}}</td>
							<td :class="statusContract(contract) ? 'text-success' : 'text-danger'">{{ statusContract(contract) ? 'Si' : 'No' }}</td>
							<td>{{contract.contract_number}}</td>
							<td>{{contract.start_date}}</td>
							<td>{{contract.end_date}}</td>
							<td>{{contract.status}}</td>
							<td>{{contract.observations}}</td>
							<td>
								<button type="button" id="editContract" class="btn btn-light btnEditContract" data-toggle="modal" data-target="#modalEditContract" @click="contractEdit = contract">
									Editar
								</button>								
							</td>
							<td>
								<button type="button" id="modalProducts" class="btn btn-light btnEditContract" data-toggle="modal" data-target="#modalPrices" @click="getProducts(contract.id)">
									Productos
								</button>								
							</td>							
						</tr>						
				</tbody>
		</table>
		<modal-edit-contract :client="client" :contract="contractEdit"/>		
		<modal-prices :contract="contract"/>
	</div>
</template>
<script>
import axios from 'axios';
import ModalPrices from './../modal-prices/modal-prices.vue'
import ModalEditContract from './../modal-edit-contract/modal-edit-contract.vue'
import { mapState } from 'vuex'
export default {
	name: 'TableContracts',
	props: ['client', '_contracts'],
	computed: {
		contracts: {
			get () {
				return this.$store.state.contracts
			},
			set (value){
				this.$store.commit('changeContracts', value)				
			}
		},
	},
	methods: {
		statusContract(contract){
			var start_date = new Date(contract.start_date)
			var end_date = new Date(contract.end_date)
			var today = new Date()
			return today >= start_date && today <= end_date
		},
    getProducts(contractId){
      axios.get(`/contracts/${contractId}`).then(res=>{
        if(res.status == 200){
          this.contract = res.data          
        }
      })          
		}
	},
	data() {
		return {
			contract: null,
			contractEdit: null,
		}
	},
	created () {
		this.contracts = this._contracts
	},
	components: {
		'modal-prices': ModalPrices,
		'modal-edit-contract': ModalEditContract
	}
}
</script>
<style scoped>

</style>